import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import "./ScheduleTable.css";

const ScheduleTable = () => {
  const [headers, setHeaders] = useState([]);
  const [scheduleData, setScheduleData] = useState([]);

  useEffect(() => {
    // Load the Excel file
    fetch("/schedule.xlsx")
      .then((response) => response.arrayBuffer())
      .then((data) => {
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const parsedData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        // Extract headers (first row)
        const extractedHeaders = parsedData[0];
        setHeaders(extractedHeaders);

        // Extract data (excluding the first row)
        const formattedData = parsedData.slice(1).map((row) => ({
          time: row[0],
          days: row.slice(1),
        }));

        setScheduleData(formattedData);
      });
  }, []);

  return (
    <div className="schedule-container">
      <h1 className="rules-title">Race Schedule</h1>
      <table className="schedule-table">
        <thead>
          <tr className="table-header">
            {headers.map((header, index) => (
              <th key={index}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {scheduleData.map((row, index) => (
            <tr
              key={index}
              className={index % 2 === 0 ? "row-even" : "row-odd"}
            >
              <td className="time-column">{row.time}</td>
              {row.days.map((event, i) => (
                <td key={i} className="event-column">
                  {event || "-"}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ScheduleTable;
